import HttpService from "../base/HttpService";
export default class MoonshotService extends HttpService {
  static api = process.env.VUE_APP_BASE_API;
  getFinancialImpact(param) {
    const api = this.api + "financial-impact";

    return this.get(param, api);
  }
  getDataFinancialImpactChart(param,id) {
    const api = this.api + `financial-impact/${id}`;

    return this.get(param, api);
  }
  getDataTotalMilestone(param) {
    const api = this.api + "financial-impact/total-milestone";

    return this.get(param, api);
  }
  getDataTotalMilestoneStatus(param) {
    const api = this.api + "financial-impact/total-milestons-status";

    return this.get(param, api);
  }
  getDataNetZero(param) {
    const api = this.api + "financial-impact/net-zero";

    return this.get(param, api);
  }
  getDataMoonshotMilestoneTimeline(param) {
    const api = this.api + "milestone/timeline";

    return this.get(param, api);
  }
  getDataMoonshotMilestoneV2(param) {
    const api = this.api + "milestone";

    return this.get(param, api);
  }
  getDataImprovement(param) {
    const api = this.api + "financial-impact/improvement";

    return this.get(param, api);
  }
  getAllData(param){
    const api = this.api + "moonshot";

    return this.get(param, api);
  }
  getDataImpactChart(param){
    const api = this.api + "moonshot/detail";

    return this.get(param, api);
  }
  getDataDetailMM(param){
    const api = this.api + "milestone/detail";

    return this.get(param, api);
  }
  getDataDetailInitiative(param){
    const api = this.api + "milestone/detail-initiative";

    return this.get(param, api);
  }
}
